export {
  validateEmailType,
  validatePasswordLength,
  validatePasswordType,
  isRequired
} from './shared_validations'



// WEBPACK FOOTER //
// ./src/js/validations/index.js